import { ChangeDetectionStrategy, Component } from "@angular/core";
import { RouterLink } from "@angular/router";
import { ButtonComponent } from "@sxm-content-creators/tools-ds";

@Component({
    selector: "app-error-page",
    templateUrl: "./error-page.component.html",
    styleUrl: "./error-page.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [RouterLink, ButtonComponent]
})
export class ErrorPageComponent {}
